module.exports = __webpack_public_path__ + "fonts/la-brands-400.fb598c9c.woff";